import { Component, Input, OnInit } from '@angular/core';
import {
  ChartDataset,
  ChartOptions,
  ChartType,
  Plugin,
  ScaleOptions
} from 'chart.js';

@Component({
  selector: 'ds365-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss'],
  standalone: false,
})
export class ChartComponent implements OnInit {
  @Input() chartData: ChartDataset[];
  @Input() chartLabels: string[];
  @Input() chartType: ChartType;
  @Input() chartLegend = true;
  @Input() chartPlugins: Plugin[] = [];

  
  @Input() chartColors: (
    | string
    | CanvasGradient
    | CanvasPattern
    | (string | CanvasGradient | CanvasPattern)[]
    | any
  )[] = [];

  private _chartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom' as const,
        labels: {
          
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          
        },
      } as ScaleOptions<'linear'>,
    },
  };

  @Input('chartOptions')
  set chartOptions(options: ChartOptions) {
    
    this._chartOptions = this.deepMerge(this._chartOptions, options);
  }

  get chartOptions(): ChartOptions {
    return this._chartOptions;
  }

  constructor() {}

  ngOnInit() {
    if (this.chartColors && this.chartData) {
      this.applyColors();
    }
  }

  private applyColors(): void {
    if (!this.chartData || !this.chartColors) return;

    this.chartData.forEach((dataset, index) => {
      const normalized = this.normalizeColor(this.chartColors[index]);
      if (!normalized.backgroundColor && !normalized.borderColor) return;

      if (dataset.type === 'line' || this.chartType === 'line') {
        dataset.borderColor = normalized.borderColor;
        dataset.backgroundColor = normalized.backgroundColor;
      } else {
        dataset.backgroundColor = normalized.backgroundColor;
        dataset.borderColor = normalized.borderColor;
        dataset.borderWidth = 1;
      }
    });
  }

  /**
   * Deep merge objects for chart options
   */
  private deepMerge(target: any, source: any): any {
    const output = { ...target };

    if (this.isObject(target) && this.isObject(source)) {
      Object.keys(source).forEach(key => {
        if (this.isObject(source[key])) {
          if (!(key in target)) {
            Object.assign(output, { [key]: source[key] });
          } else {
            output[key] = this.deepMerge(target[key], source[key]);
          }
        } else {
          Object.assign(output, { [key]: source[key] });
        }
      });
    }

    return output;
  }

  private isObject(item: any): boolean {
    return item && typeof item === 'object' && !Array.isArray(item);
  }
  private normalizeColor(color: any): { backgroundColor?: string; borderColor?: string } {
    if (!color) return {};

    if (typeof color === 'string') {
      return {
        backgroundColor: color,
        borderColor: color,
      };
    }
    if (typeof color === 'object') {
      return {
        backgroundColor: color.backgroundColor ?? color.borderColor,
        borderColor: color.borderColor ?? color.backgroundColor,
      };
    }

    return {};
  }
}
